// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

import "./Style.css";
import axiosInstance from "../../../../hooks/axiosInstance";
// import axios from 'axios';

export default function ViewCustomer({
  showView,
  closeModal,
  refreshPage,
  customer,
})
{
  const handleClose = () => {
    closeModal();
  };

  const [customers, setCustomer] = useState([]);

  useEffect(() => {
    if (customer) {
      setCustomer(customer);
    }
  }, [customer]);

  const customerCards = customer ? (
    <Card className="mb-3">
      <Card.Body>
        <Card.Text>
          <strong>First Name:</strong> {customer.first_name}
          <br />
          <strong>Last Name:</strong> {customer.last_name}
          <br />
          <strong>Email:</strong> {customer.email}
          <br />
          <strong>Phone:</strong> {customer.phone}
          <br />
          <strong>Customer Code:</strong> {customer.customer_code}
          <br />
          <strong>Turnover:</strong> {customer.turnover}
          <br />
          <strong>Country:</strong> {customer.country}
          <br />
          <strong>State:</strong> {customer.state}
          <br />
          <strong>City:</strong> {customer.city}
          <br />
          <strong>Area:</strong> {customer.area}
          <br />
          <br />
        </Card.Text>
      </Card.Body>
    </Card>
  ) : (
    <p>No company details available.</p>
  );

  return (
    <div className="ViewTransaction">
      <Modal show={showView} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>View Customer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>
          {customerCards}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#c4281b", border: "none" }}
            onClick={refreshPage}
          >
            Refresh
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
